import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

/**
 * Provide any value that can be converted to date with moment
 */
@Pipe({ name: 'timeToAnotherTimeZoneConversion' })
export class TimeToAnotherTimeZoneConversion implements PipeTransform {
  transform(time: any, timezone: string) {
    return moment(time)
      .tz(timezone)
      .format('YYYY-MM-DD hh:mm:ss A');
  }
}